var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02671e-05 6.97251C-0.00088483 6.78914 0.0307729 6.60736 0.0932271 6.43759C0.155681 6.26783 0.247703 6.11342 0.364018 5.98323L5.38399 0.409776C5.501 0.279861 5.63991 0.176807 5.7928 0.106498C5.94569 0.0361882 6.10955 -5.95776e-08 6.27503 -5.50819e-08C6.44051 -5.05862e-08 6.60437 0.0361882 6.75726 0.106498C6.91015 0.176807 7.04906 0.279861 7.16607 0.409776C7.28309 0.539691 7.37591 0.693923 7.43924 0.863665C7.50256 1.03341 7.53516 1.21534 7.53516 1.39906C7.53516 1.58279 7.50256 1.76472 7.43924 1.93446C7.37591 2.10421 7.28309 2.25844 7.16607 2.38835L3.01205 6.97251L7.00292 11.5706C7.1313 11.6988 7.23447 11.855 7.30599 12.0295C7.3775 12.2039 7.41583 12.3929 7.41856 12.5846C7.4213 12.7762 7.38838 12.9665 7.32188 13.1433C7.25538 13.3202 7.15671 13.48 7.03206 13.6126C6.90741 13.7453 6.75945 13.8479 6.59744 13.9141C6.43543 13.9804 6.26285 14.0088 6.09049 13.9976C5.91814 13.9864 5.74971 13.9359 5.59576 13.8491C5.4418 13.7624 5.30562 13.6413 5.19574 13.4935L0.351467 7.92C0.130193 7.66519 0.00455777 7.32643 7.02671e-05 6.97251Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.f3ea7b43fa55442fc72f78f4f73c18da.svg";
export { ForwardRef as ReactComponent };